// akhila 11/08/2022 2701350359 adding report notes
// akhila  11/10/2022 2701350359 added createdby column and removed add icon
// akhila 11/11/2022 2701350359 bugFix sorting in table
// Saikrishna 12/08/2022 2701350359 Revoked add note functionality
// Akhila 12/09/2022 2701350359 Added form Notes
// Ashraf 12/09/2022 2701350359 fixed reset notes issue
//  Dilip 12/12/2022 2701350359 changed tooltip
// Ashraf 12/14/2022 2701350359 fixed role access
// Ashraf 12/19/2022 2701350359 fixed notes search page break
// kavyareddy 12/19/2022 2701350359 changed dropdown for createdBy and noteType payload
// Raghu 12/22/2022 2701350359 Table footer stylings
// Raghu 12/26/2022 2701350359 Removed Dialog Component
// Prakash 02/13/2023 2698403495 Added New UI Style-classes for fields.
// Akhila 06/07/2023 2698403495 Added code and description
// Ravi 07/24/2023 2698403495 passed recordId in notes payload
// Dilip-pds 10/19/2023 2698403495 fixed created by dropdown issue

import React, {createRef, useState, useEffect} from 'react';
import {TablePagination, Button, Grid} from '@material-ui/core';
import {tableIcons} from '../../../../components/TableIcons';
import {httpPaginationPost} from '../../../../util/Rest';
import {useDispatch, useSelector} from 'react-redux';
import AddIcon from '@material-ui/icons/Add';
import {defaultRows} from '../../../../constants/ReusableTablePagination';
import {
  postSystemNotes,
  ResetMessage as resetMessage,
  resetNotesStatus,
} from '../../../../redux/reducers/BRE/AddReportMaster';
import AddUserDefinedNotes from '../../../../components/AddUserDefinedNotes';
import GuiTable from '../../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../../constants/ReusableConstants';
import DialogBox from './../../../../components/DialogBox';
import SearchNotesForm from '../../../../components/SearchNotes/searchNotesForm';
import {REPORTING_EXPORT, WORK_QUEUE_SETUP} from '../../../../constants/ReusableRoleAccess';

const ReportNote = ({
  open,
  dialogClose,
  title,
  maxWidth,
  value,
  handleSubmit,
  condition,
  buttonCondition,
  reportCodeData,
  workQueue,
}) => {
  const tableRef = createRef();
  const [charLimitMsg, setCharLimitMsg] = useState(false);
  const [webSocketOnClose, setWebSocketOnClose] = useState();
  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState(false);

  const {systemNotesStatus, isSystemNoteLoading} = useSelector(
    ({addReportMaster}) => addReportMaster,
  );
  useEffect(() => {
    if (systemNotesStatus === 200) {
      tableRef?.current && tableRef.current.onQueryChange();
      handleDialogClose();
      dispatch(resetNotesStatus());
      setTimeout(() => {
        dispatch(resetMessage());
      }, 3000);
    }
  }, [systemNotesStatus]);

  useEffect(() => {
    if (submit) {
      tableRef?.current?.onQueryChange();
    }
  }, [submit, searchData]);

  const dispatchRecordFormatSystemNotes = (data) => {
    dispatch(
      postSystemNotes({
        code: reportCodeData ? reportCodeData?.reportCode : '',
        noteText: data,
        reportId: reportCodeData ? reportCodeData?.reportId : '',
      }),
    );
  };
  let transcription = '';
  const moment = require('moment-timezone');
  const columns = [
    {
      title: 'Note Date & Time',
      field: 'noteDate',
      type: 'datetime',
      dateSetting: {locale: 'en-US'},
      render: (rowData) => (
        <>
          {rowData?.noteDate && moment(rowData.noteDate).format('MM/DD/YYYY')}
          {` `}
          {rowData?.noteTime && moment(rowData.noteTime, 'HH:mm').format('hh:mm A')}
        </>
      ),
    },
    {
      title: 'Note Text',
      field: 'noteText',
      cellStyle: {
        // minWidth: "550px",
        wordBreak: 'break-word',
      },
      render: (rowData) => <span style={{whiteSpace: 'pre-wrap'}}>{rowData.noteText}</span>,
    },
    {
      title: 'Created By',
      field: 'userId',
    },
    {
      title: 'Note Type',
      field: 'noteType',
    },
  ];
  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  const [isAddaNoteDialogOpen, setAddaNoteDialogOpen] = useState(false);
  const {roleData} = useSelector(({role}) => role);
  const reportRoleAccess = roleData?.window?.[REPORTING_EXPORT]?.RE?.add;
  const workQueueSetupAccess = roleData?.window?.[WORK_QUEUE_SETUP]?.WQS?.add;
  // console.log(reportMasterDisableAdd, "reportMasterDisableAddreportMasterDisableAddreportMasterDisableAdd");
  const handleDialogClose = () => {
    stop(webSocketOnClose);
    transcription = '';
    setAddaNoteDialogOpen(false);
  };
  const handleSelectedNotesOption = () => {
    setAddaNoteDialogOpen(true);
  };
  return (
    <>
      <DialogBox
        title="User Defined Notes"
        button2Text="Save"
        button1Text="Cancel"
        open={isAddaNoteDialogOpen}
        dialogClose={handleDialogClose}
        maxWidth={'md'}
      >
        {isAddaNoteDialogOpen && (
          <AddUserDefinedNotes
            transcription={transcription}
            setWebSocketOnClose={setWebSocketOnClose}
            charLimitMsg={charLimitMsg}
            isLoading={isSystemNoteLoading}
            setCharLimitMsg={setCharLimitMsg}
            dispatchRecordFormatSystemNotes={dispatchRecordFormatSystemNotes}
            disableByRoleAccess={'enable'}
          />
        )}
      </DialogBox>

      <Grid className="system-notes-dialog">
        <SearchNotesForm
          setSearchData={setSearchData}
          searchData={searchData}
          submit={submit}
          setSubmit={setSubmit}
          reportCodeData={reportCodeData}
          workQueue={workQueue}
          moduleName={'report'}

        />
        <div className="custom-table new-standard-textfields custom-toolbar-icons custom-actions-icon global-field-table">
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `report/find/all/notes`;
                const bodyObj = {
                  code: reportCodeData?.reportCode,
                  limit: rows,
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                  search: '',
                  frameworkId: reportCodeData?.reportId ? reportCodeData?.reportId : 0,
                  noteDate: searchData?.noteDate ?
                    moment(searchData?.noteDate).format('MM/DD/YYYY') :
                    '',
                  noteText: searchData?.noteText ? searchData?.noteText : '',
                  noteType: searchData?.noteType?.key ? searchData?.noteType?.key : '',
                  createdBy: searchData?.createdBy?.userLoginName ? searchData?.createdBy?.userLoginName : '',
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                };
                if (!reportCodeData?.reportCode) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 5,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObjects;
                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(response.data.response.resultObjects.length === 1);
                        setSubmit(false);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            actions={[
              {
                icon: () => (
                  <div>
                    <Button
                      variant="outlined"
                      className="search-btn"
                      disabled={
                        (!workQueue && !reportRoleAccess) || (workQueue && !workQueueSetupAccess)
                      }
                    >
                      <AddIcon /> Add
                    </Button>
                  </div>
                ),
                disabled: (!workQueue && !reportRoleAccess) || (workQueue && !workQueueSetupAccess),
                isFreeAction: true,
                onClick: () => handleSelectedNotesOption(),
              },
            ]}
            options={{
              search: false,
              pageSize: rows,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              toolbar: true,
              pageSizeOptions: tablePageRows,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer">
                  <TablePagination
                    {...props}
                    rowsPerPageOptions={tablePageRows}
                    labelRowsPerPage={'Rows per screen:'}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
            }}
          />
        </div>
      </Grid>
    </>
  );
};

export default ReportNote;
